module.exports = __webpack_public_path__ + "img/markImages-Icon-blue.8591120e.svg";